import {DishDetailsItem} from "@apps/dish/interfaces";
import {useQuery} from "@tanstack/react-query";

import {ResponseError} from "@globals/types/utilityTypes";

import {fetchBrandDishes} from "../BrandService";
import {BrandDishesResource} from "../interfaces";

export default function useBrandDishes(
  operatorSlug?: string,
  restaurantSlug?: string
): BrandDishesResource {
  const {data, isError, isPending, isFetched, error} = useQuery<
    DishDetailsItem[],
    ResponseError
  >({
    queryKey: ["brand-dishes", restaurantSlug, operatorSlug],
    queryFn: () => fetchBrandDishes(operatorSlug!, restaurantSlug!),
    enabled: Boolean(operatorSlug && restaurantSlug),
  });

  return {
    dishes: data,
    isLoading: !isFetched || isPending,
    isError,
    error,
  };
}
